export const CONSENT_KEYS = ['consent', 'consentText', 'consentType', 'custID'];

export const DOCUMENTS_KEY = [
  'frontUrl',
  'backUrl',
  'document',
  'file',
  'frontUrl',
  'backUrl',
  'front',
  'back',
  'image1',
  'image2',
  'image_url',
  'selfie',
  'imageURL',
  'back_url',
];

export const DEVICE_INTELLIGENCE_API_NAME = 'device_intelligence_api';

export enum INPUT_TYPES {
  FILE = 'file',
  BOOLEAN = 'boolean',
  STRING = 'string',
  NUMBER = 'number',
  ARRAY = 'array',
}
